import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { TimesheetAccessService } from '../components/timesheet-mangement/timesheet-access.service';

const TIMESHEET_BASE = ['/dashboard', 'timesheet'] as const;

function timesheetFallbackTree(
  router: Router,
  access: TimesheetAccessService,
  excludePath?: string,
): UrlTree {
  const child = access.firstAccessibleChildPath(excludePath);
  if (child) {
    return router.createUrlTree([...TIMESHEET_BASE, child]);
  }
  return router.createUrlTree(['/dashboard', 'home']);
}

/**
 * Parent `/dashboard/timesheet`: allow when any Timesheet surface is granted.
 */
export const timesheetModuleGuard: CanActivateFn = () => {
  const router = inject(Router);
  const access = inject(TimesheetAccessService);
  access.refresh();
  if (access.canAccessTimesheetModule()) {
    return true;
  }
  return router.createUrlTree(['/dashboard', 'home']);
};

/**
 * Time Entries / RM / PM timesheet children (submodule 16 view or manage).
 */
export const timesheetEntriesGuard: CanActivateFn = () => {
  const router = inject(Router);
  const access = inject(TimesheetAccessService);
  access.refresh();
  if (access.canViewTimesheets()) {
    return true;
  }
  return timesheetFallbackTree(router, access, 'my-timesheet');
};
